<template>
  <div class="center-tree">
    <el-tree ref="tree" default-expand-all :data="tree" :expand-on-click-node="true" :render-content="showPopBox ? renderContent : undefined"
             :filter-node-method="filterNode"
             @node-collapse="nodeCollapse"
             @node-click="handleNodeClick"
    />

    <el-dialog title="批量添加楼层" :visible.sync="dialogFormVisible">
      <div style="display: flex;justify-content: center">
        <el-input size="mini" style="width: 120px" v-model="startFloor"  />
        <span style="margin: 0 10px;line-height: 28px">——</span>
        <el-input size="mini" style="width: 120px" v-model="endFloor" />
      </div>
      <div style="margin-top: 30px;color: #999999;">请输入（含）起始楼层及（含）结束楼层</div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="confirm">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Vue from 'vue'
import {nSuccess, nSuccessFunc, nWarn} from '../../utils/notice'
import {pattern} from '../../utils/regular'
import {createAnErrorWithTip, errorHandler} from '../../utils/errorHandler'
import {treeApi} from '../../view/api/TreeApi'

export default {
  name: 'the-tree',
  props: {
    filterKey: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: '标题'
    },
    keyName: {
      type: String,
      default: '键名'
    },
    showPopBox: {
      type: Boolean,
      default: true
    },
    maxDepth: {
      type: Number,
      default: 4
    },
    options: {
      type: Object,
      default () {
        return {
          1: [],
          2: ['add'],
          3: ['add', 'patch', 'delete'],
          4: ['patch', 'delete']
        }
      }
    },
    update: {
      type: Object,
      default () {
        return {
          render: () => [],
          addNode: this._print,
          removeNode: this._print,
          editNode: this._print
        }
      }
    }
  },
  watch: {
    'filterKey' (val) {
      this.$refs.tree.filter(val)
    }
  },
  data () {
    return {
      tree: [],
      treeData: [],
      treeFromServer: [],
      detailForm: {
        title: '添加楼层',
        show: false,
        then: () => {
        },
        type: ''
      },
      dialogFormVisible: false,
      startFloor: '',
      endFloor: '',
      treeParentCode: ''
    }
  },
  created () {
    this.render(0)
  },
  methods: {
    filterNode (value, data) {
      if (!value) return true
      return data._label.indexOf(value) !== -1
    },
    render (code) {
      this.update.render(code)
        .then(list => {
          let newArr = []
          for (let i = 0; i < this.treeData.length; i++) {
            if (this.treeData[i].parentCode !== code) {
              newArr.push(this.treeData[i])
            }
          }
          this.treeData = newArr
          this.treeData.push.apply(this.treeData, list)
          // let maxParentID = 0
          // for (let j = 0; j < this.treeData.length; j++) {
          //   if (this.treeData[j].parentId > maxParentID) {
          //     maxParentID = this.treeData[j].parentId
          //   }
          // }
          // for (let k = 0; k < this.treeData.length; k++) {
          //   if (this.treeData[k].parentId === maxParentID && this.treeData[k].id) {
          //     let weakData = {
          //       id: '',
          //       level: this.treeData[k].level + 1,
          //       label: '',
          //       _label: '',
          //       name: '',
          //       parentId: this.treeData[k].id
          //     }
          //     newArr.push(weakData)
          //   }
          // }
          // this.treeData = newArr
          // setTimeout(() => {
          this.convertData()
          if (list.length === 1 && list[0].parentCode == 0) {
            this.render(list[0].code)
          }
          // })
        })
    },

    convertData () {
      /**
       * 组装节点
       * @function
       * @param nodes
       */
      const packNode = (nodes) => {
        const getNodes = nodeId =>
          this.treeData.filter(n => n.parentCode === nodeId)

        nodes.forEach(node => {
          const children = getNodes(node.code)
          node.children = children
          if (children.length > 0) {
            packNode(children)
          }
        })
      }
      /**
       * 格式化原始数据
       */
      this.treeData
        .forEach(it => {
          it.edidable = false
          it.label = it._label
        })

      /**
       * 生成顶层节点
       */
      const tree = this.treeData.filter(tree => tree.parentCode == 0)
      /**
       * 开始组装节点
       */
      packNode(tree)

      this.tree = tree
    },
    copyObj (obj) {
      var newobj = {}
      for (var attr in obj) {
        newobj[attr] = obj[attr]
      }
      return newobj
    },
    confirm () {
      let fromData = {
        endFloor: this.endFloor,
        level: 3,
        parentCode: this.treeParentCode,
        startFloor: this.startFloor
      }
      treeApi.addPatchFloors(fromData)
        .then(() => {
          nSuccess('添加成功')
          this.tree = []
          this.treeData = []
          this.endFloor = ''
          this.startFloor = ''
          this.dialogFormVisible = false
          this.render(0)
        })
        .catch(errorHandler('添加楼层失败'))
    },

    /* *********
     三种操作
     ********* */
    append (event, node, parentData) {
      event.stopPropagation()
      if (node.level >= this.maxDepth) {
        nWarn(`最多${this.maxDepth}级`)
        return
      }
      let newData = {code: '', label: '', children: {}}
      let appendData = {
        code: '',
        level: parentData.level + 1,
        label: '',
        _label: '',
        name: '',
        parentCode: parentData.code
      }
      this.treeData.push(appendData)
      this.convertData()
      Vue.nextTick(() => {
        let domNodes = this.getTargetChildDomNode(event.target)
        let domNode = domNodes[domNodes.length - 1]
        this.setEditable(domNode)
        domNode.style.overflow = 'visible'
        domNode.oninput = this.onEnter(domNode)
        new Promise((resolve) => {
          domNode.onblur = resolve
        })
          .then(event => this.checkInput(event, newData))
          // 转换
          .then((val) => {
            return {
              _label: val,
              parentCode: parentData.code
            }
          })
          // 发送
          .then(data => this.update.addNode(data))
          .then(() => {
            domNode.innerHTML = ''
          })
          .then(nSuccessFunc('添加成功'))
          .then(() => { this.render(parentData.code) })
          .then(() => this.setEditableFalse(domNode))
          .catch(error => {
            errorHandler('请求失败')(error)
            domNode.innerHTML = ''
            this.setEditableFalse(domNode)
            domNode.style.overflow = 'hidden'
            this.render(parentData.code)
          })
      })
    },
    appendBatch (event, node, parentData) {
      event.stopPropagation()
      this.treeParentCode = node.data.code
      this.dialogFormVisible = true
    },
    edit (event, data) {
      event.stopPropagation()
      const domNode = this.getTargetDomNode(event.target)
      domNode.style.overflow = 'visible'
      let oldVal = domNode.innerHTML
      new Promise((resolve) => {
        this.setEditable(domNode)
        domNode.oninput = this.onEnter(domNode)
        domNode.onblur = resolve
      })
        .then(event => this.checkInput(event, data))
        .then((val) => {
          data.label = val
          data._label = val
        })
        .then(() => this.update.editNode(data))
        .then(nSuccessFunc('修改成功'))
        .then(() => this.render(data.parentCode))
        .then(() => console.log(data))
        .then(() => this.setEditableFalse(domNode))
        .catch(error => {
          errorHandler('请求失败')(error)
          domNode.innerHTML = oldVal
        })
        .then(() => { domNode.style.overflow = 'hidden' })
    },
    remove (event, data) {
      this.$confirm(`确认删除${this.title}`)
        .then(() => this.update.removeNode(data.code))
        .then(nSuccessFunc('删除成功'))
        .then(() => this.render(data.parentCode))
        .catch(errorHandler('请求失败'))
    },
    getTargetDomNode (domNode) {
      const c = domNode.parentNode.parentNode.parentNode.getElementsByClassName('left')
      if (c.length === 1) {
        return c[0]
      }
    },
    getTargetChildDomNode (domNode) {
      return this.getTargetDomNode(domNode)
        .parentNode.parentNode.parentNode.getElementsByClassName('left')
    },
    onEnter (domNode) {
      return e => {
        const isEnter = e.inputType === 'insertParagraph'
        const isBackward = e.inputType === 'deleteContentBackward'
        const isForward = e.inputType === 'deleteContentForward'
        if (isEnter ||
          (!isBackward && !isForward && e.data === null)
        ) {
          e.target.innerHTML = e.target.innerText.trim()
          domNode.blur()
        }
      }
    },
    checkInput ({target}, data) {
      if (target.innerText === '') {
        target.innerHTML = data._label
        return Promise.reject(createAnErrorWithTip('节点为空'))
      }
      if (target.innerText === data._label) {
        return Promise.reject(createAnErrorWithTip('您未做修改', '用户未修改'))
      }
      if (target.innerText.trim().length > 20) {
        return Promise.reject(createAnErrorWithTip('不能超20个字符'))
      }
      if (!pattern.basicAndCN.test(target.innerText.trim())) {
        return Promise.reject(createAnErrorWithTip('只允许包含中文，字母，数字，下划线'))
      }
      return target.innerText
    },
    setEditable (domNode) {
      domNode.contentEditable = true
      domNode.focus()
      const range = getSelection()
      range.selectAllChildren(domNode)
      range.collapseToEnd()
      return domNode
    },
    setEditableFalse (domNode) {
      domNode.contentEditable = false
      domNode.style.overflow = 'visible'
    },
    /* *********
     三种操作 结束
     ********* */
    renderContent (h, {node, data}) {
      const nodeOption = this.options[node.level]
      const showOperateBox = (event) => {
        event.target.classList.add('show')
      }
      const hideOperateBox = (event) => {
        event.target.classList.remove('show')
      }
      const handleAdd = event => this.append(event, node, data)
      const handleAddBatch = event => this.appendBatch(event, node, data)
      const handlePatch = event => this.edit(event, data)
      const handleDelete = () => this.remove(node, data)
      if (data.level === 2) {
        return (
          <span class="item">
          <span class="left">{data._label}</span>
          <i class="el-icon-more icon-more"
             onMouseenter={showOperateBox}
             onMouseleave={hideOperateBox}
          >
            <span class="pop-box">
              {nodeOption.includes('add')
                ? <i class="el-icon-plus operate" onClick={handleAddBatch}>批量添加</i>
                : ''}
              {nodeOption.includes('patch')
                ? <i class="el-icon-edit operate" onClick={handlePatch}>修改</i>
                : ''}
              {nodeOption.includes('delete')
                ? <i class="el-icon-minus operate" onClick={handleDelete}>删除</i>
                : ''}
            </span>
          </i>
        </span>
        )
      } else {
        return (
          <span class="item">
          <span class="left">{data._label}</span>
          <i class="el-icon-more icon-more"
             onMouseenter={showOperateBox}
             onMouseleave={hideOperateBox}
          >
            <span class="pop-box">
              {nodeOption.includes('add')
                ? <i class="el-icon-plus operate" onClick={handleAdd}>添加</i>
                : ''}
              {nodeOption.includes('patch')
                ? <i class="el-icon-edit operate" onClick={handlePatch}>修改</i>
                : ''}
              {nodeOption.includes('delete')
                ? <i class="el-icon-minus operate" onClick={handleDelete}>删除</i>
                : ''}
            </span>
          </i>
        </span>
        )
      }
    },
    nodeCollapse (data, node, $event) {
      // data.children = []
      // node.childNodes = []
      // for (let y = 0; y < this.treeData.length; y++) {
      //   if (this.treeData[y].parentCode === data.code) {
      //     this.treeData.splice(y, 1, [])
      //   }
      // }
      // this.render(data.parentCode)
    },
    handleNodeClick (data, $event) {
      this.render(data.code)
      window.sessionStorage.setItem('buildingyqCode', data.code)
      window.sessionStorage.setItem('buildingLevel', data.level)
      // const currentId = $event.id
      // const isChecked = this.$refs.tree.getCheckedKeys().includes(currentId)
      // const checkedKeys = isChecked ? [] : [currentId]
      // this.$refs.tree.setCheckedKeys(checkedKeys)
      this.$emit('selected', $event)
    }
  }
}
</script>

<style scoped>
  .el-tree{
    height: 740px!important;
    overflow-y: auto;
  }
</style>

<style lang="less">
  .center-tree .el-tree-node .el-tree-node__children {
    overflow: visible!important;
  }

  .center-tree {
    .item {
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: space-between;
      font-size: 14px;
      padding-right: 8px;
    }
    .left {
      display: block;
      text-align: left;
      min-width: 50px;
      max-width: 120px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      user-select: none;
      &:hover {
        text-overflow: unset;
        max-width: unset;
      }
    }
    .icon-more {
      display: block;
      font-size: 12px;
      color: #999999;
      position: relative;
      padding: 2px;
      overflow: visible;
      margin-right: 55px;
      .pop-box {
        display: none;
        background-color: #fff;
        width: 65px;
        position: absolute;
        top: 10px;
        left: 12px;
        user-select: none;
        z-index: 2018;
      }
      .operate {
        display: none;
        font-size: 12px;
        color: #999999;
        padding: 5px 2px;
        margin-top: -1px;
        border: 1px solid #999999;
      }
      .operate:hover {
        color: #1362FF;
        border: 1px solid #1362FF;
      }
      &.show .pop-box {
        display: block !important;
        .operate {
          display: block !important;
        }
      }
    }
  }
</style>

<style lang="less">
  label {
    margin-bottom: 0 !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/Tree/the-tree.vue